export const CANONICAL_URL = 'https://outreach-course-signup-2026a.working-with-street-children.org'

const TITLE = 'WWSC Free WhatsApp Course: From the Streets Up — 20 Lessons for Better Outreach'
const TEXT  = 'Join this free WhatsApp Street Outreach Course for frontline workers working with street children. 1 key topic per week, fun quizzes & audio shows!'

const encodedTitle = encodeURIComponent(TITLE)
const encodedText  = encodeURIComponent(TEXT)
const encodedUrl   = encodeURIComponent(CANONICAL_URL)
const encodedBody  = encodeURIComponent(`${TEXT}\n\n${CANONICAL_URL}`)

export const EMAIL_URLS = {
  gmail:   `https://mail.google.com/mail/?view=cm&fs=1&su=${encodedTitle}&body=${encodedBody}`,
  outlook: `https://outlook.live.com/mail/deeplink/compose?subject=${encodedTitle}&body=${encodedBody}`,
  mailto:  `mailto:?subject=${encodedTitle}&body=${encodedBody}`,
}

export function shareTo(platform) {
  switch (platform) {
    case 'whatsapp':
      window.open(`https://wa.me/?text=${encodedText}%20${encodedUrl}`, '_blank', 'noopener,noreferrer')
      break
    case 'facebook':
      window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}&quote=${encodedText}`, '_blank', 'noopener,noreferrer')
      break
    case 'email':
      window.location.href = EMAIL_URLS.mailto
      break
  }
}
